import compose from 'lodash/flowRight'
import * as React from 'react'
import {connect} from 'react-redux'

import withHook from '../../../hocs/withHook'
import {useAppSelector} from '../../../hooks/react-redux'
import type {State} from '../../../reducers/types'
import {getBuildTriggerBuildArg} from '../../../rest/builds'
import {getBuildHref} from '../../../routes'
import {getBuildTriggered, getFullPath, getIsSakuraUI} from '../../../selectors'
import {restApi} from '../../../services/rest'
import {resolveWebEntityLink} from '../../../utils/entityLinks'
import {withVisibility} from '../Visible/Visible.hocs'

import BuildTriggeredBy from './BuildTriggeredBy'
import type {OwnProps, StateProps} from './BuildTriggeredBy.types'

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const triggered = getBuildTriggered(state, props.buildId)

  if (!triggered) {
    return {
      text: null,
      buildType: null,
      buildPath: null,
    }
  }

  const {displayText, buildType, date} = triggered
  return {
    text: displayText,
    buildType,
    buildPath: buildType
      ? getFullPath(state, {
          nodeType: 'bt',
          id: buildType,
        })
      : null,
    date,
  }
}

export default compose(
  connect(mapStateToProps),
  withVisibility(),
  withHook(({isVisible, buildId, buildType}) => {
    const isSakuraUI = useAppSelector(getIsSakuraUI)
    const [fetchTriggerBuildData, {buildNumber, buildUrl}] =
      restApi.endpoints.getBuild.useLazyQuery({
        selectFromResult: ({data}) => {
          const triggerBuild = data?.triggered?.build
          return {
            buildNumber: triggerBuild?.number,
            buildUrl:
              isSakuraUI && triggerBuild?.id != null
                ? getBuildHref(triggerBuild.id, buildType)
                : resolveWebEntityLink(triggerBuild),
          }
        },
      })
    React.useEffect(() => {
      if (isVisible && buildNumber == null && buildType != null) {
        fetchTriggerBuildData(getBuildTriggerBuildArg(buildId))
      }
    }, [buildId, buildNumber, buildType, fetchTriggerBuildData, isVisible])
    return {buildNumber, buildUrl}
  }),
)(BuildTriggeredBy)
